import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import MuiButton from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { styled } from '@mui/material/styles';

const StyledIcon = styled(Icon)(({ theme }) => ({
  marginRight: theme.spacing(1)
}));

const RouterLink = React.forwardRef((props, ref) => {
  return <Link ref={ref} {...props} />;
});

RouterLink.displayName = 'RouterLink';

class Button extends Component {
  static propTypes = {
    to: PropTypes.string,
    flat: PropTypes.bool
  };

  render() {
    const {
      label,
      icon,
      primary,
      secondary,
      danger, // do not pass to DOM
      flat,
      variant,
      to,
      ...rest
    } = this.props;

    const leftIcon = icon ? (
      typeof icon === 'string' ? (
        <StyledIcon>{icon}</StyledIcon>
      ) : (
        icon
      )
    ) : null;

    const props = {
      ...rest,
      color: primary
        ? 'primary'
        : secondary || danger
        ? 'secondary'
        : 'inherit',
      component: to ? RouterLink : undefined,
      variant: variant || (!flat ? 'contained' : 'text')
    };

    if (to) {
      props.to = to;
    }

    return (
      <MuiButton {...props}>
        {leftIcon}
        {label}
      </MuiButton>
    );
  }
}

export default Button;
